/**
* In View Physician function is used to retrieve the Physician details, hospital info and patients info details and * its functions declare this file
**/
import { useParams,Link } from 'react-router-dom';
import { useState,useEffect} from 'react';
import ApiService from './../../services/ApiService';
import { goBack ,convertTimeFormat,convertS3privateToPublic } from './../../services/UtilsService';
import { useTranslation } from 'react-i18next';

function ViewPhysician() {
	//Intial variable declaration
	let { id } = useParams();
    const [data,setData]=useState({});
    const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();

	//components initialize function and api handling
	useEffect(()=>{
	   (async()=>{
		 if(id){
		     var response=await ApiService.getPhysician(id);
			 if(response.status===200)
				setData(response.data);	 
			 if (response.data.item) {
				const createdBy = response.data.item.created_by; // Get the created_by value
				localStorage.setItem("created_by", createdBy); // Store it in localStorage with the key "created_by"
			 }	
		 }
	   })();
   },[id]);
   
   
  return (
   <main id="main" className="main">
		{/*Page Title Section*/}
		<div className="pagetitle clearfix">
		<div className="float-start">
		  <h1>{t('profile.viewPhysicianInfo')}</h1>
			<nav>
				<ol className="breadcrumb">
				  <li className="breadcrumb-item"><Link to={role === 4 ? '/hospital/admin/dashboard' : '/admin/dashboard'}>{t('sidebar.home')}</Link></li>
				  <li className="breadcrumb-item"><Link to={role === 4 ? '/hospital/admin/physician' : '/admin/physician'}>{t('sidebar.physician')}</Link></li>
				  <li className="breadcrumb-item active">{t('profile.viewPhysicianInfo')} </li>
				</ol>
			</nav>
		</div>
		<div className="float-end mt-2 me-1">
			<span onClick={goBack}   className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
		</div>
	</div>
	{/*Page Title Section*/}
	
	{/*Page Content Section*/}
	<section>
	<div className="row">
		<div className="col-xxl-4">
			{/*ProfileImg*/}
			<div className="card profile-img">
				<div className="card-body">
					<div className="top-bar">
						{(data && data?.item && data?.item?.photo ==='default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/user-avatar.png" alt="IMG" />}
						{(data && data?.item && data?.item?.photo !=='default.png') && <img src={convertS3privateToPublic(data?.item?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
						<h1 className="text-capitalize">{data.item?.first_name?data.item.first_name+' '+data.item.last_name:'--'}</h1>
						
					</div>
					<div className="center-bar clearfix">
						<div className="d-flex align-items-center mb-4">
							<div className={`info-icon ${role === 4 ? 'admin-info-icon' : ''}`}>
								<i className="iconly-Bold-Send"></i>
							</div>
							<div className="ms-2">
								<p className={`mb-0 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}>{t('profile.email')}</p>
								<span className="h6 text-dark" style={{ wordBreak : "break-word"}}>{data.item?.email?data.item.email:'--'}</span>
							</div>
						</div>
						<div className="d-flex align-items-center mb-4">
							<div className={`info-icon ${role === 4 ? 'admin-info-icon' : ''}`}>
								<i className="iconly-Bold-Calling"></i>
							</div>
							<div className="ms-2">
								<p className={`mb-0 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}>{t('profile.phone')}</p>
								<span className="h6 text-dark">{data.item?.mobileNumber?data.item.countryCode+' '+data.item.mobileNumber:'--'}</span>
							</div>
						</div>
					</div>
					<div className="d-grid mt-4">
						<Link to={role === 4 ? `/hospital/admin/edit-physician/${id}` : `/admin/edit-physician/${id}`}  className={`btn btn-block ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-outline-tmBlue'}`}>
							<i className="ri-edit-2-fill align-middle"></i> {t('profile.editProfile')}
						</Link>
					</div>
				</div>
			</div>
		</div>
		
		<div className="col-xxl-8">
			<div className="card profile-info">
				<div className="card-body pt-4">
					{/*Physician Info*/}
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className={`secTitle ${role === 4 ? 'admin-secTitle' : ''}`}>
								<h1>{t('profile.physicianInfo')}</h1>
							</div>
							<div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
								<h6>{t('profile.location')}</h6>
								<p className="text-capitalize">
								 {data.item && data.item.address_one
									?'Address One: '+ data.item.address_one + ', '
									: ''}{data.item && data.item.address_one && <br/ >}
								  {data.item && data.item.address_two
									? 'Address Two: '+data.item.address_two + ', '
									: ''}{data.item && data.item.address_two && <br/ >}
									{(data.item && data.item.city ) ?'City: '+ data.item.city+', ':''}{data.item && data.item.city && <br/ >}
									{(data.item && data.item.state) ? 'State: '+ data.item.state+', ':''} {data.item && data.item.state && <br/ >}
									{(data.item && data.item.zipcode) ? 'Zipcode: '+ data.item.zipcode:''}{data.item && data.item.zipcode && <br/ >}
									{!(data.item && (data.item.city || data.item.state || data.item.zipcode)) ? '--' : ''}</p>
								
									<h6>{t('profile.outOfOffice')}</h6>
									<p>
									{data?.item?.out_of_office?.length === 0
										? "--" // Case 1: No out-of-office dates
										: data?.item?.out_of_office
											?.map((range) => {
											// Remove square brackets and split the range
											const [start, end] = range.replace(/[\[\]]/g, "").split(",");
											if (start === end) {
												// Case 3: Same start and end date
												return new Date(start).toLocaleDateString("en-GB");
											} else {
												// Case 2: Different start and end dates
												return `${new Date(start).toLocaleDateString("en-GB")} -to- ${new Date(end).toLocaleDateString("en-GB")}`;
											}
											})
											.join(", ")} {/* Join all formatted dates with a comma */}
									</p>
							</div>
						</div>
					</div>
					{/*Hospital Info*/}
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className={`secTitle ${role === 4 ? 'admin-secTitle' : ''}`}>
								<h1>{t('profile.hospitalInfo')}</h1>
							</div>
							<div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
								<div className="table-responsive">	
									<table className="table table-borderless theme-table">
										<thead>
										  <tr>
											<th scope="col">{t('profile.hospital')}</th>
											<th scope="col">{t('profile.visitingDays')}</th>
											<th scope="col">{t('profile.visitingHours')}</th>
											<th scope="col">{t('profile.consultingDuration')}</th>
										  </tr>
										</thead>
										{data && data?.hospitalInfo?.length ? (
										<tbody>
											{data && data.hospitalInfo && data.hospitalInfo.map(item=>(
											<tr key={item.id}>
												<td className="prty-td">
													<Link to={role === 4 ? `` : `/admin/hospital/${item.hospital}`}>
														<h5 className="table-title text-capitalize">{item?.hospital_name?item?.hospital_name:'--'}</h5>
													</Link>
												</td>					
											<td className="text-capitalize">
												{item?.days && item?.days.length > 0 ? (
													item?.days
													.map(day =>[day.trim()] || '--') 
													.reduce((acc, curr, index) => (
													<>
														{acc}
														{index > 0 && ', '}
														{curr}
													</>
													), '')) : (
														'--' // Change: Added fallback for no days
													)}
											</td>
											<td>
												{item.startTime && item.endTime ? `${convertTimeFormat(item.startTime)} to ${convertTimeFormat(item.endTime)}` : '--'}
											</td>
												<td>{item.consultingDuration!==null ? item.consultingDuration + ' Mins' : '--'}</td>	
											</tr>
											))}
											</tbody>
											) : (
											<tbody>
												<tr>
													<td colSpan="4" className="text-center">{t('common.noRecord')}</td>
												</tr>
											</tbody>
											)}
									</table>
								</div>
							</div>
						</div>
					</div>
					{/*Patients Info*/}
					<div className="row">
						<div className="col-xxl-12 px-3 mb-5">
							<div className={`secTitle ${role === 4 ? 'admin-secTitle' : ''}`}>
								<h1>{t('profile.PatientInfo')}</h1>
							</div>
							<div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
								<div className="table-responsive">	
									<table className="table table-borderless theme-table">
										<thead>
										  <tr>
											<th scope="col">{t('profile.patient')}</th>
											<th scope="col">{t('profile.familyMember')}</th>
										  </tr>
										</thead>
										{data && data?.parentInfo?.length ? (
										<tbody>
											{data && data.parentInfo && data.parentInfo.map(item=>(
											<tr key={item.id}>
												<td  className="prty-td">
													<Link to={role === 4 ? `/hospital/admin/view-parent/${item.parent}` : `/admin/parent/${item.parent}`}className="text-capitalize">
														<h5 className="table-title">{item?.parent_name ? item?.parent_name:'--'}</h5>
													</Link>
												</td>
												<td>{item?.members?item?.members:0}</td>		
											</tr>
											))}
											</tbody>
											) : (
											<tbody>
												<tr>
													<td colSpan="2" className="text-center">{t('common.noRecord')}</td>
												</tr>
											</tbody>
											)}
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
{/* End Page Content Section */}		
</main>
  );
}

export default ViewPhysician;
